import { Schema } from "mongoose"
import { z } from "zod"

import {
  ZRBTenantSubscriptionIntervalUnit,
  ZRBTenantSubscriptionScope,
  ZRBTenantSubscriptionStatus,
  ZRBTenantSubscriptionType,
} from "./RBTenantSubscriptionEvent"


export const ZRBTenantSubscriptionProjection = z.object({
  tenantId: z.string(),
  subscriptionId: z.string(),
  type: ZRBTenantSubscriptionType,
  parentSubscriptionId: z.string().optional(),
  scope: ZRBTenantSubscriptionScope,
  scopeId: z.string().optional(),
  planKey: z.string(),
  priceId: z.string().optional(),
  status: ZRBTenantSubscriptionStatus,
  intervalUnit: ZRBTenantSubscriptionIntervalUnit,
  intervalCount: z.number().int().min(1),
  modules: z.array(z.string()),
  billingAnchor: z.date(),
  currentPeriodStart: z.date(),
  currentPeriodEnd: z.date(),
  cancelAtPeriodEnd: z.boolean(),
  cancelAt: z.date().optional(),
  canceledAt: z.date().optional(),
  scheduledPlanKey: z.string().optional(),
  scheduledPlanEffectiveAt: z.date().optional(),
  provider: z.string().optional(),
  latestEventId: z.string(),
  latestEventAt: z.date(),
  projectedAt: z.date(),
})

export type IRBTenantSubscriptionProjection = z.infer<typeof ZRBTenantSubscriptionProjection>

export const RBTenantSubscriptionProjectionSchema: Schema = new Schema({
  tenantId: { type: String, required: true, index: true },
  subscriptionId: { type: String, required: true },
  type: { type: String, required: true, enum: ZRBTenantSubscriptionType.options },
  parentSubscriptionId: { type: String },
  scope: { type: String, required: true, enum: ZRBTenantSubscriptionScope.options },
  scopeId: { type: String },
  planKey: { type: String, required: true },
  priceId: { type: String },
  status: { type: String, required: true, enum: ZRBTenantSubscriptionStatus.options },
  intervalUnit: { type: String, required: true, enum: ZRBTenantSubscriptionIntervalUnit.options },
  intervalCount: { type: Number, required: true, min: 1 },
  modules: { type: [String], required: true, default: [] },
  billingAnchor: { type: Date, required: true },
  currentPeriodStart: { type: Date, required: true },
  currentPeriodEnd: { type: Date, required: true },
  cancelAtPeriodEnd: { type: Boolean, required: true, default: false },
  cancelAt: { type: Date },
  canceledAt: { type: Date },
  scheduledPlanKey: { type: String },
  scheduledPlanEffectiveAt: { type: Date },
  provider: { type: String },
  latestEventId: { type: String, required: true },
  latestEventAt: { type: Date, required: true },
  projectedAt: { type: Date, required: true },
})

RBTenantSubscriptionProjectionSchema.index({ tenantId: 1, subscriptionId: 1 }, { unique: true })
RBTenantSubscriptionProjectionSchema.index({ tenantId: 1, scope: 1, scopeId: 1 })
